import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {NgSelect2Module} from 'ng-select2';
import {TasksComponent} from './tasks.component';
import {WidgetsModule} from '../../_metronic/partials/content/widgets/widgets.module';
import {MatTabsModule} from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';

import {MatRippleModule, MatNativeDateModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {TaskViewComponent} from './task-view/task-view.component';
import {TimeBetweenPipe} from "../../shared/timeBetween.pipe";
import {MatDividerModule} from "@angular/material/divider";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';
import {TasksListComponent} from './tasks-list/task-list.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {SharedModuleModule} from '../../../shared-module/shared-module.module';

const routes: Routes = [
    {
        path: 'solicitarile-mele',
        component: TasksListComponent
    }
]

@NgModule({
    declarations: [TasksComponent,
        TasksListComponent,
        TaskViewComponent,
        TimeBetweenPipe,],
    exports: [
        TimeBetweenPipe,
        TaskViewComponent
    ],
    providers: [
        TimeBetweenPipe,
        MatSnackBar
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        MatNativeDateModule,
        MatRippleModule,
        NgSelect2Module,
        WidgetsModule,
        MatTabsModule,
        MatDatepickerModule,
        MatInputModule,
        MatSelectModule,
        MatDividerModule,
        MatCheckboxModule,
        NgbCollapseModule,
        MatProgressSpinnerModule,
        MatIconModule,
        SharedModuleModule,
    ]
})
export class TasksModule { }
